import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DoctorsService } from "@services/doctors/doctors.service";
import { Doctor } from "@interfaces/doctors";
import { ActivatedRoute, Router } from "@angular/router";

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import {NzMessageService} from 'ng-zorro-antd/message';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-doctors-list',
  imports: [
    FormsModule,
    NzButtonModule,
    NzDropDownModule,
    NzIconModule,
    NzInputModule,
    NzTableModule,
    NzSpinModule,
    NzPaginationModule
  ],
  templateUrl: './doctors-list.component.html',
  standalone: true,
  styleUrl: './doctors-list.component.scss'
})
export class DoctorsListComponent implements OnInit {
  doctors?: Doctor[];
  listOfDisplayData: Doctor[] = [];
  page = 1;
  pageLimit?: number;
  pageSize = 10; // Should match service perPage
  total = 0; // Total number of doctors
  searchValue = '';
  visible = false;

  constructor(
    private doctorsService: DoctorsService,
    private router: Router,
    private route: ActivatedRoute,
    private nzMessageService: NzMessageService
  ) {
    this.doctorsService.doctorsListObservable$
      .subscribe((doctors: any) => {
        this.page = this.doctorsService.page;
        this.pageLimit = this.doctorsService.pageLimit;
        this.pageSize = this.doctorsService.perPage;
        console.log('page', this.page, 'pageLimit', this.pageLimit);
        this.doctors = doctors;
        this.listOfDisplayData = [...(doctors || [])];

        // Calculate total for pagination based on total pages and page size
        if (this.pageLimit && this.pageSize) {
          this.total = this.pageLimit * this.pageSize;
        }

        // Apply current search if there's a search value
        if (this.searchValue.length > 0) {
          this.search();
        }
      });
  }

  ngOnInit() {
    console.log('DoctorsListComponent initialized');
  }

  openDoctor(doctor: Doctor) {
    this.router.navigate([`${doctor.id}/patients`], { relativeTo: this.route });
  }

  onPageChange(page: number): void {
    this.doctorsService.fetchDoctors(page)
      .subscribe((data: any) => {
        this.doctors = data;
        this.listOfDisplayData = [...data];
        // Use resetDoctorsList instead of updateDoctorsList for pagination
        this.doctorsService.resetDoctorsList(data);
        // Apply current search if there's a search value
        if (this.searchValue.length > 0) {
          this.search();
        }
      });
  }

  deleteDoctor(id: string) {
    this.doctorsService.deleteDoctor(id)
      .subscribe(() => {
        this.doctors = this.doctors?.filter(doctor => doctor.id !== id);
      });

  }

  reset(): void {
    this.searchValue = '';
    this.search();
  }

  search(): void {
    this.visible = false;
    if (!this.doctors) return;

    this.listOfDisplayData = this.doctors.filter((doctor: Doctor) =>
      `${doctor.first_name} ${doctor.last_name}`.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
    );
  }

  cancel(): void {
    this.nzMessageService.info('click cancel');
  }

  confirm(): void {
    this.nzMessageService.info('click confirm');
  }

  beforeConfirm(id: string): Observable<boolean> {
    return new Observable(observer => {
      this.doctorsService.deleteDoctor(id)
        .subscribe({
          next: () => {
            this.doctors = this.doctors?.filter(doctor => doctor.id !== id);
            this.nzMessageService.success('Doctor deleted successfully');
            observer.next(true);
            observer.complete();
          },
          error: (error) => {
            this.nzMessageService.error('Failed to delete doctor');
            observer.next(false);
            observer.complete();
          }
        });
    });
  }
}
